export default __webpack_public_path__ + "static/media/480_dummy2016-musikschule01-de.acaeb06b.png";